<rwidget-planner-trip-details [tripId]="tripId"></rwidget-planner-trip-details>
